module.exports = __webpack_public_path__ + "img/dashboard.e5298bea.svg";